import React from 'react';
import { DatePickerProps } from 'antd';
import * as S from './styles';

export default function DatePicker(props: Readonly<DatePickerProps>): JSX.Element {
	return <S.DatePickerWrapper {...props} />;
}
